// extracted by mini-css-extract-plugin
export default {"container":"QMS_container__rgR1E","title":"QMS_title__tp8Pw","error":"QMS_error__nK0JA"};